

import React, { useEffect, useRef, useState } from "react";

import { Card, Col, Form, Row, Button, Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import "jspdf-autotable";
import { ToastContainer, toast } from "react-toastify";

import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { usePermissions } from "../contexts/PermissionContext";
import moment from "moment";
import jsPDF from "jspdf";
import { Helmet } from "react-helmet";
import InfoPill from "../InfoPill";
import PdfHeader from "../layout/common/PdfHeader";



const StaffReport = (props) => {
  const labels = {
    beforeSelect: " ",
  };
  let [body, setBody] = useState([]);
  const [contacts, setContacts] = useState([]);
  const { rolePermissions, userInfo } = usePermissions();
  const [reportData, setReportData] = useState({
    recordtype: "",
  });
  const [staffOptions, setStaffOptions] = useState([]);

  body = body
    ? body.map((item, index) => ({
        ...item,
        serialNumber: index + 1,
      }))
    : [];

  const headers = [
    {
      title: "Sr. No.",
      prop: "",
      width: "50px",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>{row.serialNumber}</div>
      ),
    },
    { title: "Employee Name", prop: "staffname", isFilterable: true },
    { title: "Designation", prop: "recordtype", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    {
      title: "Mobile",
      prop: "phone",
      isFilterable: true,
      cell: (row) => <div style={{ textAlign: "right" }}>{row.phone}</div>,
    },
    {
      title: "Joining Date",
      prop: "createddate",
      isFilterable: true,
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {moment(row.createddate).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Gender",
      prop: "gender",
      isFilterable: true,
      cell: (row) => <div style={{ textAlign: "left" }}>{row.gender}</div>,
    },
  ];

  useEffect(() => {
    async function init() {
      try {
        const result = await schoolApi.fetchStaffContacts();
        if (result.success) {
          setBody(result.contacts);
          setContacts(result.contacts);
          const options = result.contacts
            .map((item) => ({
              value: item.recordtype,
              label: item.recordtype,
            }))
            .filter(
              (option, index, self) =>
                index === self.findIndex((t) => t.value === option.value)
            );
          setStaffOptions(options);
        } else {
          toast.error("Record not found");
          setBody([]);
          setContacts([]);
        }
      } catch (error) {
        if (error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
        }
      }
    }
    init();
  }, []);

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const renderPdfHeader = (doc) => {
      const logoUrl = `/${userInfo?.tenantcode}-sidebar-logo.png`;
      doc.addImage(logoUrl, "PNG", 14, 10, 27, 27);
      doc.setFontSize(18);
      doc.text(userInfo?.companyname || "Company Name", 145, 20, {
        align: "center",
      });
      doc.setFontSize(10);
      const address = `${userInfo?.companystreet}, ${userInfo?.companystate}-${userInfo?.companypincode}, ${userInfo?.companycountry}`;
      const addressLines = doc.splitTextToSize(address, 180);
      doc.text(addressLines, 145, 26, { align: "center" });
      doc.setFontSize(12);
      doc.text(`Date: ${currentDate}`, 280, 20, { align: "right" });

      doc.line(14, 40, 283, 40);
      doc.text("Staff Fee Report", 125, 47);
    };

    renderPdfHeader(doc);
    const tableData = body.map((row, index) => [
      index + 1,
      row?.staffname,
      row?.recordtype,
      row?.email,
      row?.phone,
      moment(row.createddate).format("DD/MM/YYYY"),
      row?.gender,
    ]);
    const lastIndex = body.length;

    doc.autoTable({
      head: [
        [
          "Sr No.",
          "Employee Name",
          "Designation",
          "Email",
          "Mobile",
          "Joining Date",
          "Gender",
        ],
      ],
      body: tableData,
      didDrawCell: (data) => {
        doc.setLineDash([1, 1], 0);
      },

      styles: {
        borderTop: "2px solid #000",
        margin: "10px 0",
        border: 1, // General border setting for all cells
        lineWidth: 0.1, // Border thickness
        lineColor: [0, 0, 0], // Border color (Black)
        fontSize: 10,
      },
      headStyles: {
        fillColor: "rgb(41,56,70)", // Background color (RGB: Blue)
        textColor: [255, 255, 255], // Text color (White)
        halign: "center", // Center-align header text
        fontStyle: "bold", // Make text bold
      },
      columnStyles: {
        0: { halign: "right", cellWidth: 14 },
        4: { halign: "right" },
        5: { halign: "right" },
      },
      margin: { top: 50 },
    });

    doc.save("StaffReports.pdf");
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setReportData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSearch = async () => {
    try {
      if (reportData.recordtype) {
        const result = await schoolApi.fetchStaffContactsName(reportData);
        if (result.success) {
          setBody(result.contacts);
        } else {
          return toast.error(result.message);
        }
      } else {
        if (contacts.length > 0) setBody(contacts);
        else return toast.error("No Employee Found!!!");
      }
    } catch (error) {
     
    }
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={3} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Staff Report
          </Link>
        </Col>
      </Row>
      <Row className="mt-5 m-0 px-4">
        <Card className="px-0 py-3" style={{ marginTop: "-18px" }}>
          <Row className="m-0">
            <Col lg={12} className="px-3">
              <h5 className="fw-semibold">Filters</h5>
            </Col>
            <hr />
          </Row>
          <Row className="flex-row mt-3 mb-2 px-4">
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">
                  Employee Type
                </Form.Label>
                <Form.Select
                  name="recordtype"
                  onChange={handleChange}
                  value={reportData.recordtype}
                >
                  <option key="default" value="">
                    All
                  </option>
                  {staffOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col lg={4} className="d-flex align-items-end">
              <div className="button-wrapper">
                <Button onClick={handleSearch} variant="primary">
                  Search
                </Button>
                {body.length > 0 && (
                  <Button
                    onClick={handleDownload}
                    variant="primary"
                    className="ms-3"
                  >
                    Download
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </Row>
      {body.length > 0 && (
        <Row className="mt-5 m-0 px-4">
          <Card className="px-0 py-3">
            <Row className="flex-row mb-3 px-4">
              <Col lg={12} className="p-0">
                <Row className="mt-5 m-0 px-4">
                  <div id="reportContent">
                    <PdfHeader />
                    <div
                      style={{ borderTop: "2px solid #000", margin: "10px 0" }}
                    ></div>
                    <Row className="mt-2">
                      <Col lg={12} className="px-3">
                        <h5
                          style={{ textAlign: "center" }}
                          className="fw-semibold"
                        >
                          Staff Report
                        </h5>
                      </Col>
                    </Row>
                  </div>
                  <Col lg={12} className="mt-1 px-1">
                    <DatatableWrapper
                      headers={headers}
                      body={body}
                      paginationOptionsProps={{
                        initialState: {
                          rowsPerPage: 10,
                          options: [5, 10, 15, 20],
                        },
                      }}
                    >
                      <Row className="mb-3">
                        <Col
                          lg={3}
                          sm={4}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Filter />
                        </Col>
                        <Col
                          xs={12}
                          sm={6}
                          lg={5}
                          className="d-flex flex-col justify-content-start align-items-start"
                        >
                          <PaginationOptions labels={labels} />
                          <div className="mt-2">
                            <InfoPill
                              left="Total Students"
                              right={body?.length}
                            />
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          sm={6}
                          lg={4}
                          className="d-flex flex-col justify-content-end align-items-end"
                        ></Col>
                      </Row>
                      <Table
                        striped
                        className="transaction-report-table"
                        responsive
                        id="inventory-table-details"
                      >
                        <TableHeader />
                        {body?.length > 0 ? (
                          <>
                            <TableBody />
                            {}
                          </>
                        ) : (
                          <TableBody>
                            <tr>
                              <td colSpan={7} className="text-center">
                                No records found
                              </td>
                            </tr>
                          </TableBody>
                        )}
                      </Table>
                      <Pagination />
                    </DatatableWrapper>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Row>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      ;
    </>
  );
};

export default StaffReport;
